import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://apiagenda.datakaltara.my.id/api';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_URL,
  withCredentials: true
});

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth API
export const login = async (username, password) => {
  const response = await api.post('/auth/login', { username, password });
  return response.data;
};

export const register = async (userData) => {
  const response = await api.post('/auth/register', userData);
  return response.data;
};

export const getCurrentUser = async () => {
  const response = await api.get('/auth/me');
  return response.data;
};

// Agenda API
export const getAgendas = async (filters = {}) => {
  const params = new URLSearchParams(filters);
  const response = await api.get(`/agendas?${params}`);
  return response.data;
};

export const createAgenda = async (agendaData) => {
  const response = await api.post('/agendas', agendaData);
  return response.data;
};

export const updateAgenda = async (id, agendaData) => {
  const response = await api.put(`/agendas/${id}`, agendaData);
  return response.data;
};

export const deleteAgenda = async (id) => {
  const response = await api.delete(`/agendas/${id}`);
  return response.data;
};

export const updateAgendaStatus = async (id, status) => {
  const response = await api.put(`/agendas/${id}/status`, { status });
  return response.data;
};

export const getTodayAgendas = async () => {
  const response = await api.get('/agendas/today');
  return response.data;
};

export const getUpcomingAgendas = async () => {
  const response = await api.get('/agendas/upcoming');
  return response.data;
};

export const getPendingAgendas = async () => {
  const response = await api.get('/agendas/pending');
  return response.data;
};

// User API
export const getUsers = async () => {
  const response = await api.get('/users');
  return response.data;
};

export const createUser = async (userData) => {
  const response = await api.post('/users', userData);
  return response.data;
};

export const updateUser = async (id, userData) => {
  const response = await api.put(`/users/${id}`, userData);
  return response.data;
};

export const deleteUser = async (id) => {
  const response = await api.delete(`/users/${id}`);
  return response.data;
};

export const bulkImportUsers = async (usersData) => {
  const response = await api.post('/users/bulk-import', { users: usersData });
  return response.data;
};

// Error handler
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear token and redirect to login if unauthorized
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
